import { render, staticRenderFns } from "./SaveDraft.vue?vue&type=template&id=2022dde6&"
import script from "./SaveDraft.vue?vue&type=script&lang=js&"
export * from "./SaveDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports